type TSetValue = (_name: any, _value: any) => void;
type TRemoveSpecialCharacters = (value: string, name: string, setValue: TSetValue, regExp: RegExp) => void;

export const removeSpecialCharacters: TRemoveSpecialCharacters = (value, name, setValue, regExp) =>
	setValue(name, value.replace(regExp, ''));
